<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="non_para_mts"><span class="right_1" epub:type="pagebreak" id="page_i" title="i"><i><b>A chance encounter with a handsome groomsman turns into so much more for a newly single wedding florist in this romantic reader-favorite story from Kianna Alexander!</b></i></span></p>
<p class="non_para_ts">After discovering her fiancé’s public and utterly embarrassing infidelity, florist Renata McPherson is left dateless to her beloved client’s nuptials. But meaningful eye contact with one devastatingly handsome groomsman leaves Renata unexpectedly breathless…</p>
<p class="non_para_ts">As a contractor, Amir Robertson has quite the knack for design. Though he has no plans for rebuilding the gorgeous shop owner’s heart…at first. Their no-strings-attached arrangement could soon fail when a secret that joins them forever is revealed.</p>
<p class="non_para_ts"><i>Previously published.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369702654_Frontmatter.vue?0a78262e